import { Component } from '@angular/core';
import { itineraryReselector } from 'src/app/store/reselectors/programs.reselector';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Itinerary } from 'globals/store/programs.data';
import { CommonModule } from '@angular/common';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { TopMenuComponent } from './top.menu';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'program-itinerary',
    template: `
<loader-pane-fragment [trace]="traceNames.viewProgramItinerary"></loader-pane-fragment>
<top-menu [showPrint]="true" ></top-menu>
<mobile-menu></mobile-menu>
<div class="no_date" *ngIf="!has_date">Only room/locations with dates will appear in the summary.</div>
<div class="wrap920 itinerary_panel" *ngIf="!!has_date">
  <ng-container *ngFor="let it of itinerary; index as idx; last as last">
  <b class="mobile_date mobile" *ngIf="idx == 0 || programService.dateID(itinerary[idx].date) != programService.dateID(itinerary[idx-1].date)">{{ it.date | date:'EEEE d MMMM y' }}</b>
  <div class="itinerary" [ngClass]="{narrow: last || programService.dateID(itinerary[idx].date) == programService.dateID(itinerary[idx+1].date)}">
    <b class="date_heading desktop">{{idx == 0 || programService.dateID(itinerary[idx].date) != programService.dateID(itinerary[idx-1].date) ? (it.date | date:'EEEE d MMMM y'): '&nbsp;'}}</b>
    <div class="contents">
        <span class="time">{{it.time}}</span>
        <div class="venue">
            <div><b>{{it.title}}</b></div>
            <div>{{it.location}}{{it.location && it.venue ? ', ':''}}{{it.venue}}</div>
            <div class="address">{{it.address}}</div>
            <div class="address p1" *ngIf="it.expectedNumber">Expected numbers: {{it.expectedNumber}}</div>
        </div>
    </div>
  </div>
  </ng-container>

</div>
    `,
    styleUrls: [`./program.itinerary.scss`, '../../page.scss'],
    standalone: true,
    imports: [CommonModule, MobileMenuComponent, TopMenuComponent, LoaderPaneFragmentComponent],
})
export class ProgramItineraryComponent extends Wrapper<ProgramItineraryComponent> {

    has_date
    itinerary: Itinerary[] = []
    page_name = PAGE_NAME.itinerary;
    traceNames = traceNames

    constructor() {
      super()
      this.subProp(this.store.select('programs','has_date'), 'has_date')
      this.subProp(this.store.select(itineraryReselector), 'itinerary')
      this.uiService.changePageTitle("Itinerary View",true)
    }

}

